/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 利用可能係数セット
 * @export
 * @interface AvailableCoefficientSet
 */
export interface AvailableCoefficientSet {
    /**
     * 係数セットID
     * @type {string}
     * @memberof AvailableCoefficientSet
     */
    coefficientSetId?: string;
    /**
     * 係数セット表示名
     * @type {string}
     * @memberof AvailableCoefficientSet
     */
    coefficientSetDisplayName?: string;
}

/**
 * Check if a given object implements the AvailableCoefficientSet interface.
 */
export function instanceOfAvailableCoefficientSet(value: object): value is AvailableCoefficientSet {
    return true;
}

export function AvailableCoefficientSetFromJSON(json: any): AvailableCoefficientSet {
    return AvailableCoefficientSetFromJSONTyped(json, false);
}

export function AvailableCoefficientSetFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableCoefficientSet {
    if (json == null) {
        return json;
    }
    return {
        
        'coefficientSetId': json['coefficientSetId'] == null ? undefined : json['coefficientSetId'],
        'coefficientSetDisplayName': json['coefficientSetDisplayName'] == null ? undefined : json['coefficientSetDisplayName'],
    };
}

export function AvailableCoefficientSetToJSON(value?: AvailableCoefficientSet | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'coefficientSetId': value['coefficientSetId'],
        'coefficientSetDisplayName': value['coefficientSetDisplayName'],
    };
}

